import { DateUtil, Icon, TableColumn, TableRow } from '@aon/aon-tws-common-ui';
import moment from 'moment';
import * as React from 'react';
import styled from 'styled-components';
import { IAudience, IColumn, IEmailTemplate, IValidationErrorCollection } from '../../../models';
import { ToastType } from '../../audience/ToastType';
import { ReminderEmailModal } from '../../audience/email/ReminderEmailModal';
import { TableLinkWrapper } from '../../common';
import { ReminderActionMenu } from './ReminderActionMenu';

export const CursorWrapper = styled.span`
	cursor: pointer;
`;

export interface IReminderRowProps {
	key: number | string | undefined;
	columns: IColumn[];
	reminderEmail: IEmailTemplate;
	audience: IAudience;
	surveyId: number;
	reminderEmailValidationError?: IValidationErrorCollection;
	AddReminderEmailValidationErrors: (validationError?: IValidationErrorCollection) => any;
	DeleteEmailTemplate: (emailTemplateId: number) => void;
	UpdateEmailTemplate: (emailTemplate: IEmailTemplate) => void;
	Toast: (type: ToastType, message: string) => void;
	readOnly?: boolean;
}

export interface IReminderRowState {
	reminderModalToggle: boolean;
}

export class ReminderRow extends React.PureComponent<IReminderRowProps, IReminderRowState> {
	constructor(props: IReminderRowProps) {
		super(props);
		this.isReadOnly = this.isReadOnly.bind(this);
		this.state = { reminderModalToggle: false };
		this.getEmailPropertyText = this.getEmailPropertyText.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	public render() {
		const { reminderModalToggle } = this.state;
		return (
			<>
				<TableRow>{this.props.columns.map((column: IColumn) => this.getEmailPropertyText(column))}</TableRow>
				<ReminderEmailModal
					audience={this.props.audience}
					reminderEmail={this.props.reminderEmail}
					modalOpen={reminderModalToggle}
					validationErrors={this.props.reminderEmailValidationError}
					addReminderToList={this.handleUpdate}
					addReminderEmailValidationErrors={this.props.AddReminderEmailValidationErrors}
					closeModal={() => this.toggleModal(false)}
					toast={this.props.Toast}
					readOnly={this.isReadOnly()}
				/>
			</>
		);
	}

	private isReadOnly() {
		let readOnly = this.props.readOnly;
		if (!readOnly) {
			readOnly = this.props.reminderEmail.scheduledFor ? moment(this.props.reminderEmail.scheduledFor).isBefore(new Date()) : false;
		}
		return readOnly;
	}

	private toggleModal(open: boolean) {
		this.setState({ reminderModalToggle: open });
	}

	private handleUpdate(email: IEmailTemplate) {
		this.props.UpdateEmailTemplate(email);
	}

	private getEmailPropertyText(column: IColumn) {
		const key = column.name.toLocaleLowerCase();
		let content;
		switch (column.name) {
			case 'Name':
				content = <TableLinkWrapper onClick={() => this.toggleModal(true)}>{this.props.reminderEmail.emailTemplateName}</TableLinkWrapper>;
				break;
			case 'Send Date':
				content = DateUtil.formatDateToLocal(new Date(this.props.reminderEmail.scheduledFor!));
				break;
			case 'Actions':
				content = this.isReadOnly() ? (
					<CursorWrapper onClick={() => this.toggleModal(true)}>
						<Icon name='preview' />
					</CursorWrapper>
				) : (
					<ReminderActionMenu {...this.props} audienceId={this.props.audience.audienceId} ToggleReminderModal={this.toggleModal} />
				);
				break;
			default:
				return <TableColumn key={key} />;
		}
		return <TableColumn key={key}>{content}</TableColumn>;
	}
}
